module.exports = __webpack_public_path__ + "static/img/water_3.6d4eeec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/water_3.png
// module id = 302
// module chunks = 1